import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ADD_PAGE, getCommunityShared, SAVE_PAGE } from "../../redux/actions/userReflection";
import { getCommunityPersonal } from "../../redux/actions/userReflection";

import SearchBar from "../../components/Searchbar";
import ReflectionCards from "../../components/reflectionCards";
import Sidebar from "../../components/Sidebar/Sidebar";
import axios from 'axios';
import { serverUrl } from "../../components/Helpers/Config";
import ButtonBlue from "../../components/Button/ButtonBlue";
import * as AiIcons from 'react-icons/ai';
import { showSharepost } from "../../redux/actions/sharePost";
import { tokenAuthorize } from "../../components/Helpers/Common";
import { ViewList, ViewModule } from "@material-ui/icons";
import { getUserPreference, putUserPreference } from "../../redux/actions/commonAction";
import { staticFiles } from "../../components/Helpers/Static";
import { ButtonGridNew, ButtonCommonTopNew, ButtonGridActiveNew } from "../Theme";
import Button from "../../components/Button/Button";
import ButtonCommon from "../../components/Button/ButtonCommon";
import { HiShare } from "react-icons/hi";
import Loading from "../../components/Button/Loading";
import { CommunityLoader, CommunityLoadMoreLoader } from "../../components/Button/Loader";

function Shared() {
    const SIDEBARDATA = [
        {
            title: 'Shared with me',
            iconClosed: <AiIcons.AiFillCaretRight />,
            iconOpened: <AiIcons.AiFillCaretDown />,
            item: [],
            open: true
        },
        {
            title: 'Shared with individual',
            iconClosed: <AiIcons.AiFillCaretRight />,
            iconOpened: <AiIcons.AiFillCaretDown />,
            item: [],
            open: false
        },
        {
            title: 'Shared in community',
            iconClosed: <AiIcons.AiFillCaretRight />,
            iconOpened: <AiIcons.AiFillCaretDown />,
            item: [],
            open: false
        },
    ]


    const dispatch = useDispatch();
    const reflections = useSelector(state => state.reflections.reflections)
    const [sharedPost, setsharedPost] = useState([]);
    const [sharedPostCopy, setsharedPostCopy] = useState([]);
    const page = useSelector(state => state.reflections.page)
    const sharedPosts = useSelector(state => state.reflections.sharedPosts)
    const loading = useSelector(state => state.reflections.loading)
    const hasmore = useSelector(state => state.reflections.hasmore)
    const spage = useSelector(state => state.reflections.spage)
    const shareMeMore = useSelector(state => state.reflections.shareMeMore)
    const userProfile = useSelector(state => state.auth.user)
    const pagePreference = useSelector(state => state.commonData.pagePreference)

    const isChange = useSelector(state => state.reflections.change);

    const [searchField, setSearchField] = useState('')
    const [filteredPost, setFilteredPost] = useState([])

    const [sharedWithIndividual, setsharedWithIndividual] = useState([]);
    const [sharedWithCommunity, setsharedWithCommunity] = useState([]);

    const [sharedWithIndividualCopy, setsharedWithIndividualCopy] = useState([]);
    const [sharedWithCommunityCopy, setsharedWithCommunityCopy] = useState([]);

    const [sharedWithIndividualId, setsharedWithIndividualId] = useState([]);
    const [sharedWithMeId, setsharedWithMeId] = useState([]);
    const [sharedWithCommunityId, setsharedWithCommunityId] = useState([]);

    const [filterOptions, setFilterOptions] = useState(SIDEBARDATA)
    const [selectedOption, setSelectedOption] = useState({
        type: -1,
        value: ''
    })
    const [offset, setOffset] = useState(0);
    const [isGrid, setisGrid] = useState(true);
    const [isMobile, setisMobile] = useState(false);
    const [communityMore, setCommunityMore] = useState(false);
    const [individualMore, setIndividualMore] = useState(false);
    const [offsetCommunity, setOffsetCommunity] = useState(0);
    const [offsetOthers, setOffsetOthers] = useState(0);
    const [offsetMe, setOffsetMe] = useState(0);
    const [loadMoreUnique, setLoadMoreUnique] = useState(false);
    const [sharedWithCommunityUnique, setsharedWithCommunityUnique] = useState([]);
    const [sharedWithIndividualUnique, setsharedWithIndividualUnique] = useState([]);
    const [sharedWithMeUnique, setsharedWithMeUnique] = useState([]);
    const [loadingUnique, setLoadingUnique] = useState(false);

    useEffect(() => {
        axios.get(serverUrl.SharedToOthers + `?offset=${offset}`).then(res => {
            if (res.status === 200) {
                // setsharedWithIndividual(res.data.shared_to_individuals)
                // setsharedWithIndividualCopy(res.data.shared_to_individuals)
                let shared = sharedWithIndividualCopy.concat(res.data.shared_to_individuals)
                setsharedWithIndividual(shared)
                setsharedWithIndividualCopy(shared)
                if (res.data.shared_to_individuals?.length == 0) {
                    setIndividualMore(false);
                } else {
                    setIndividualMore(true);
                }
            }
        })
            .catch((err) => {
                tokenAuthorize(err?.response?.status);
            })
        axios.get(serverUrl.SharedInCommunity + `?offset=${offset}`).then(res => {
            if (res.status === 200) {
                // setsharedWithCommunity(res.data.shared_in_community)
                // setsharedWithCommunityCopy(res.data.shared_in_community)
                let shared = sharedWithCommunityCopy.concat(res.data.shared_in_community)
                setsharedWithCommunity(shared)
                setsharedWithCommunityCopy(shared)
                if (res.data.shared_in_community?.length == 0) {
                    setCommunityMore(false);
                } else {
                    setCommunityMore(true);
                }
            }
        })
            .catch((err) => {
                tokenAuthorize(err?.response?.status);
            })
    }, [offset, isChange])

    useEffect(() => {
        axios.get(serverUrl.sharedPosts).then(res => {
            if (res.status === 200) {
                let i = 10;
                let j = 10000;
                setsharedWithCommunityId(res.data.shared_in_community);
                setsharedWithIndividualId(res.data.shared_with_others.map((data) => { data["id"] = j++; return data }));
                setsharedWithMeId(res.data.shared_with_me.map((data) => { data["id"] = i++; return data }));
            }
        })
            .catch((err) => {
                tokenAuthorize(err?.response?.status);
            })
    }, [isChange])

    useEffect(() => {
        setFilterOptions(prevState => {
            let currentOptions = [...prevState]
            // currentOptions[0].item=[{id:1,value:"Shared with individuals",count:0},{id:2,value:"Shared in community",count:0}];
            currentOptions[0].item = sharedWithMeId.map((data) => { return { id: data.id, value: data.user_name, count: data.reflection_id.length } });
            currentOptions[2].item = sharedWithCommunityId.map((data) => { return { id: data.group_id, value: data.group_name, count: data.reflection_id.length } });
            currentOptions[1].item = sharedWithIndividualId.map((data) => { return { id: data.id, value: data.user_name, count: data.reflection_id.length } });
            return currentOptions
        });
    }, [sharedWithCommunityId, sharedWithIndividualId, sharedWithMeId])

    useEffect(() => {
        dispatch(getCommunityShared(offset))
        return () => {
            dispatch({ type: SAVE_PAGE });
        };
    }, [offset]);

    useEffect(() => {
        const share = sharedPosts.sort(function (a, b) { return new Date(b.reflection_share_created) - new Date(a.reflection_share_created) });
        setsharedPost(share);
        setsharedPostCopy(share);
    }, [sharedPosts])

    useEffect(() => {

        if (!loading) {
            document.body.addEventListener("scroll", scrollEnd);
        }
        return () => {
            document.body.removeEventListener("scroll", scrollEnd);
        };

    }, [loading]);

    const scrollEnd = () => {
        if (
            window.innerHeight + document.body.scrollTop ===
            document.body.scrollHeight
        ) {
            try {
                if (hasmore) {
                    dispatch({ type: ADD_PAGE });
                }
            } catch (e) {

            }
        }
    };

    function filterPost(selectedPost) {
        const filteredList = selectedPost.filter(
            (post) => post.reflection_title.toLowerCase().includes(searchField.toLowerCase())
        )
        return filteredList;
    }

    useEffect(() => {

        // let selectedPost = [];
        // let selectedOtherPost = [];
        // let selectedCommunityPost = [];
        //shared with me
        if (selectedOption.type === 0 && selectedOption.value !== "") {
            let reflectionId = sharedWithMeId.filter((data) => {
                if (parseInt(selectedOption.value) === parseInt(data.id)) { return data }
            })
            let user_id = reflectionId[0].guid;
            axios.get(serverUrl.SharedToFilter + `/${user_id}`).then(res => {
                if (res.status == 200) {
                    let selectedPost = filterPost(res.data.reflections);
                    setsharedPost(selectedPost);
                    setsharedWithIndividual([]);
                    setsharedWithCommunity([]);

                }
            })
                .catch((err) => {
                    tokenAuthorize(err?.response?.status);
                })

        }
        //shared with individuals    
        else if (selectedOption.type === 1 && selectedOption.value !== "") {
            let reflectionId2 = sharedWithIndividualId.filter((data) => {
                if (parseInt(selectedOption.value) === parseInt(data.id)) { return data }
            })
            let user_id = reflectionId2.length === 0 ? 0 : reflectionId2[0].guid;
            if (reflectionId2.length !== 0) {
                axios.get(serverUrl.SharedToOthersFilter + `/${user_id}`).then(res => {
                    if (res.status == 200) {
                        let selectedOtherPost = filterPost(res.data.shared_to_individuals);
                        setsharedPost([]);
                        setsharedWithIndividual(selectedOtherPost);
                        setsharedWithCommunity([]);

                    }
                })
                    .catch((err) => {
                        tokenAuthorize(err?.response?.status);
                    })
            }
        }
        //shared with community
        else if (selectedOption.type === 2 && selectedOption.value !== "") {
            let reflectionId = sharedWithCommunityId.filter((data) => {
                if (parseInt(selectedOption.value) === parseInt(data.group_id)) { return data }
            })
            // let ids = reflectionId[0].reflection_id;
            let group_id = reflectionId.length === 0 ? 0 : reflectionId[0].group_id;

            if (reflectionId.length !== 0) {
                axios.get(serverUrl.SharedToGroupFilter + `/${group_id}`).then(res => {
                    if (res.status == 200) {
                        let selectedCommunityPost = filterPost(res.data.shared_in_community);
                        setsharedPost([]);
                        setsharedWithIndividual([]);
                        setsharedWithCommunity(selectedCommunityPost);

                    }
                })
                    .catch((err) => {
                        tokenAuthorize(err?.response?.status);
                    })
            }

        }
        else if (selectedOption.type === 0 && selectedOption.value === "") {
            // setsharedPost(filterPost(sharedPosts));
            setsharedPost([]);
            setOffsetMe(0);
            setLoadMoreUnique(false);
            setsharedWithMeUnique([]);
            setsharedWithIndividual([]);
            setsharedWithCommunity([]);
            getSharedWithMe();
        }
        else if (selectedOption.type === 1 && selectedOption.value === "") {
            setsharedPost([]);
            // setsharedWithIndividual(filterPost(sharedWithIndividualCopy));
            setsharedWithCommunity([]);
            setOffsetOthers(0);
            setsharedWithIndividualUnique([]);
            setLoadMoreUnique(false);
            setsharedPost([]);
            setsharedWithIndividual([]);
            getSharedWithIndividual();
        }
        else if (selectedOption.type === 2 && selectedOption.value === "") {
            setsharedWithCommunity([]);
            setOffsetCommunity(0);
            setsharedWithCommunityUnique([]);
            setLoadMoreUnique(false);
            setsharedPost([]);
            setsharedWithIndividual([]);
            getSharedWithCommunity();
            // setsharedWithCommunity(filterPost(sharedWithCommunityCopy));
        }
        else {
            setsharedPost(filterPost(sharedPosts));
            setsharedWithIndividual(filterPost(sharedWithIndividualCopy));
            setsharedWithCommunity(filterPost(sharedWithCommunityCopy));
            // selectedPost = sharedPosts;
            // selectedOtherPost = sharedWithIndividualCopy;
            // selectedCommunityPost = sharedWithCommunityCopy;
        }

    }, [selectedOption, sharedPosts, sharedWithCommunityCopy, sharedWithIndividualCopy, searchField])

    const setFilterValue = (type, value) => {
        if (((parseInt(selectedOption?.type) != parseInt(type)) && (selectedOption?.value === "" && value === "")) || (selectedOption?.value !== "" || value != "")) {
            setSelectedOption({ type, value })
        }
    }
    // const searchFeed = () => {
    //     if(searchField.length != 0){
    //       axios.get(
    //         serverUrl.Community + `/search/${searchField}`
    //       ).then(resp => {
    //             if (resp.status === 200) {
    //                 let searched = resp.data.posts
    //                 setFilteredPost(searched)
    //             }
    //       })
    //     }
    //     else{
    //       setFilteredPost(reflections)
    //     }

    // }

    const likesList = [
        { image: `${userProfile.photo}` },
        { image: `${userProfile.photo}` },
        { image: `${userProfile.photo}` }
    ]


    // return(
    //     <div className='w-full flex justify-center'>
    //         <div className='w-3/3'>
    //             <div className='w-full flex justify-end my-8'>
    //                 <div>
    //                     {/* <SearchBar setSearchField={setSearchField} onClick={searchFeed}/> */}
    //                 </div>
    //             </div>

    //             {
    //                 sharedPost.map((item, idx) => (
    //                     <ReflectionCards
    //                         item={item}
    //                         key={idx}
    //                         shareToUser={true}
    //                         // isView={false}
    //                         // handleLike={(e) => {
    //                         //   e.stopPropagation();
    //                         //   likePost(item.reflection_id, parseInt(item.like) === 1? 0:1);
    //                         // }}
    //                     />
    //                 ))
    //             }
    //         </div>
    //     </div>
    // )

    useEffect(() => {
        dispatch(getUserPreference());
        const interval = setInterval(() => {
            resize();
        }, 100)
        return () => {
            clearInterval(interval);
        }
    }, [])

    const resize = () => {
        if (window.innerWidth < 768) {
            setisMobile(true);
            setisGrid(false);
        } else {
            setisMobile(false);
            let data = localStorage.getItem("is_grid") == "true" ? true : false;
            setisGrid(data);
        }
    }

    useEffect(() => {
        let data = pagePreference["shared_is_grid"];
        setisGrid(data);
        localStorage.setItem("is_grid", data);
    }, [pagePreference])

    const updatePreference = (data) => {
        if (isGrid != data) {
            pagePreference["shared_is_grid"] = !isGrid;
            localStorage.setItem("is_grid", !isGrid);
            setisGrid(!isGrid);
            dispatch(putUserPreference(pagePreference));
        }
    }

    const loadMorePost = () => {
        setOffset(offset + 5);
    }

    const loadMorePostUnique = () => {
        if (selectedOption?.type === 0) {
            getSharedWithMe("loadmore");
        }
        if (selectedOption?.type === 1) {
            getSharedWithIndividual("loadmore");
        }
        if (selectedOption?.type === 2) {
            getSharedWithCommunity("loadmore");
        }
    }

    const getSharedWithMe = (mode) => {
        if (mode === "loadmore") {
            setLoadingUnique(true);
        }
        axios.get(serverUrl.CommunityShared + `?offset=${offsetMe}`).then(res => {
            if (res.status === 200) {
                let shared = sharedWithMeUnique.concat(res.data.reflections)
                setsharedPost(shared);
                setsharedWithMeUnique(shared);
                setOffsetMe(offsetMe + 5);
                if (res.data.reflections?.length == 0) {
                    setLoadMoreUnique(false);
                } else {
                    setLoadMoreUnique(true);
                }
                setLoadingUnique(false);
            }
            setLoadingUnique(false);
        })
            .catch((err) => {
                setLoadingUnique(false);
                tokenAuthorize(err?.response?.status);
            })
    }

    const getSharedWithIndividual = (mode) => {
        if (mode === "loadmore") {
            setLoadingUnique(true);
        }
        axios.get(serverUrl.SharedToOthers + `?offset=${offsetOthers}`).then(res => {
            if (res.status === 200) {
                let shared = sharedWithIndividualUnique.concat(res.data?.shared_to_individuals)
                setsharedWithIndividual(shared);
                setsharedWithIndividualUnique(shared);
                setOffsetOthers(offsetOthers + 5);
                if (res.data.shared_to_individuals?.length == 0) {
                    setLoadMoreUnique(false);
                } else {
                    setLoadMoreUnique(true);
                }
                setLoadingUnique(false);
            } else {
                setLoadingUnique(false);
            }
        })
            .catch((err) => {
                setLoadingUnique(false);
                tokenAuthorize(err?.response?.status);
            })
    }

    const getSharedWithCommunity = (mode) => {
        if (mode === "loadmore") {
            setLoadingUnique(true);
        }
        axios.get(serverUrl.SharedInCommunity + `?offset=${offsetCommunity}`).then(res => {
            if (res.status === 200) {
                let shared = sharedWithCommunityUnique.concat(res.data.shared_in_community)
                setsharedWithCommunity(shared);
                setsharedWithCommunityUnique(shared);
                setOffsetCommunity(offsetCommunity + 5);
                if (res.data.shared_in_community?.length == 0) {
                    setLoadMoreUnique(false);
                } else {
                    setLoadMoreUnique(true);
                }
                setLoadingUnique(false);
            } else {
                setLoadingUnique(false);
            }
        })
            .catch((err) => {
                setLoadingUnique(false);
                tokenAuthorize(err?.response?.status);
            })
    }

    return (<>
        {
            loading ?
                <CommunityLoader /> :
                <div className="flex flex-col md:flex-col lg:flex-row pt-0 mb-8">
                    <div className="flex flex-row-reverse lg:flex-col border-right-f1">
                        <div className='w-full border-bottom-f1 p-4 box-border'>
                            <SearchBar setSearchField={setSearchField} />
                        </div>
                        <Sidebar
                            data={filterOptions}
                            selectedOption={selectedOption}
                            setSelectedOption={setFilterValue}
                            isShared={true}
                        />
                    </div>
                    <div className='w-full backGroundColor pb-6'>
                        <div className="flex justify-between lg:justify-end cardBackgroundColor p-4 pb-4 mb-4 px-5 items-center">
                            <div className="lg:hidden" id="hideDropDown">
                                <ButtonCommonTopNew className="w-28 flex items-center whitespace-nowrap px-2 gap-1 border p-2 text-sm rounded-lg cursor-pointer" onClick={() => dispatch(showSharepost())}>
                                    <HiShare fontSize="small" className="w-4 h-4 cursor-pointer primaryIcon" />
                                    Share Post
                                </ButtonCommonTopNew>
                            </div>
                            <div className="">
                                <div
                                    className={`p-1 rounded-lg flex items-center ${isGrid == false
                                        ? "bg-blurred-gradient"
                                        : "bg-blurred-gradientright"
                                        } ${"cursor-pointer"}`}
                                >
                                    {isMobile == false ? (
                                        isGrid == true ? (
                                            <ButtonGridActiveNew
                                                className="grid-div"
                                                onClick={() => updatePreference(true)}
                                            >
                                                <ViewModule className={`${"gridicon-styleNew"}`} />
                                            </ButtonGridActiveNew>
                                        ) : (
                                            <ButtonGridNew
                                                className="grid-div"
                                                onClick={() => updatePreference(true)}
                                            >
                                                <ViewModule className={`${"gridicon-styleNew"}`} />
                                            </ButtonGridNew>
                                        )
                                    ) : (
                                        ""
                                    )}
                                    {isGrid == false ? (
                                        <ButtonGridActiveNew
                                            className="grid-div"
                                            onClick={() => updatePreference(false)}
                                        >
                                            <ViewList className={`${"listicon-styleNew"}`} />
                                        </ButtonGridActiveNew>
                                    ) : (
                                        <ButtonGridNew
                                            className="grid-div"
                                            onClick={() => updatePreference(false)}
                                        >
                                            <ViewList className={`${"listicon-styleNew"}`} />
                                        </ButtonGridNew>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div class={`${isGrid == true ? "grid-cols-2" : "grid-cols-1 justify-items-center"} ${"grid gap-4"} px-5`}>
                            {/* {isGrid == false ? <div className={"justify-center justify-self-center"}> : ""} */}
                            {
                                sharedPost && sharedPost.map((item, idx) => (
                                    <ReflectionCards
                                        item={item}
                                        key={idx}
                                        shareToUser={""}
                                        gridView={isGrid}
                                    />
                                ))
                            }
                            {sharedWithIndividual &&
                                sharedWithIndividual.map((item, idx) => (
                                    <ReflectionCards
                                        item={item}
                                        key={idx}
                                        shareToUser={true}
                                        isDelete={true}
                                        gridView={isGrid}
                                    />
                                ))
                            }
                            {sharedWithCommunity &&
                                sharedWithCommunity.map((item, idx) => (
                                    <ReflectionCards
                                        item={item}
                                        key={idx}
                                        shareToUser={false}
                                        gridView={isGrid}
                                    />
                                ))
                            }
                            {/* {isGrid == false ? </div> } */}
                        </div>
                        <div className="grid grid-cols-1 mt-6">
                            <div className="justify-center justify-self-center">
                                {loadingUnique && <CommunityLoadMoreLoader />}
                                {(selectedOption?.type == -1 && (communityMore == true || individualMore == true || shareMeMore == true)) &&
                                    <ButtonCommonTopNew
                                        className="px-5 border p-2 text-sm rounded-lg cursor-pointer"
                                        onClick={loadMorePost}
                                    >Load more</ButtonCommonTopNew>
                                }
                                {(selectedOption?.value === "" && ((selectedOption?.type == 0 && loadMoreUnique == true) || (selectedOption?.type == 1 && loadMoreUnique == true) || (selectedOption?.type == 2 && loadMoreUnique == true))) &&
                                    <ButtonCommonTopNew
                                        className="px-5 border p-2 text-sm rounded-lg cursor-pointer"
                                        onClick={loadMorePostUnique}
                                    >Load more</ButtonCommonTopNew>}
                            </div>
                        </div>
                    </div>

                </div>
        }
    </>);
}

export default Shared;